import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks,
} from 'body-scroll-lock-upgrade';
export default class Header{
    
    constructor() {
        this._header = document.querySelector('.js-header');
        this._docsMenu = document.querySelector('.js-docs-menu');
        this._overlay = document.querySelector('.js-menu-overlay');
        this._docsBtn = document.querySelector('.js-docs-menu-trigger');
        this._btnMobile = document.querySelector('.js-btn-mobile');
        this._nav = document.querySelector('.js-header-nav');
        this._items = document.querySelectorAll('.js-header-nav a');
        
        
        this.bindEvents();
    }
    
    bindEvents(){
        
        this._docsBtn.addEventListener('click', () => {
            this._overlay.classList.toggle('is-open');
            this._docsMenu.classList.toggle('is-open');

            this.closeMenu();
        })
        
        this._overlay.addEventListener('click', () => {
            this._overlay.classList.remove('is-open');
            this._docsMenu.classList.remove('is-open');
        })
        
        this._btnMobile.addEventListener('click', () => {
            if(this._header.classList.contains('is-open')){
                this.closeMenu();
            }
            else{
                this.openMenu();
            }
           
           this._overlay.classList.remove('is-open');
           this._docsMenu.classList.remove('is-open');
        });
       
        app.nodesEventListener('click', this._items, () => {
           this.closeMenu(); 
        });
    }   
    
    openMenu(){
        this._header.classList.add('is-open');
        disableBodyScroll(this._nav);
    }
    
    closeMenu(){
        this._header.classList.remove('is-open');
        clearAllBodyScrollLocks();
    }
    
}